import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RelatorioDTO } from '../../../../dtos/relatorio-dto';
import { Procedimento } from '../../../../procedimento/procedimento';
import { ProcedimentoService } from '../../../../procedimento/procedimento.service';
import { RelatorioProcedimentoService } from '../../relatorio-procedimento.service';
import { Filial } from '../../../../filial/filial';
import { FilialService } from '../../../../filial/filial.service';

@Component({
  selector: 'app-rel-marcacao-procedimento',
  templateUrl: './rel-marcacao-procedimento.component.html',
  styleUrls: ['./rel-marcacao-procedimento.component.css']
})
export class RelMarcacaoProcedimentoComponent implements OnInit {

  formularioDeMarcacaoDeExames: FormGroup;

  listaFiliais: Filial[];

  listaDeProcedimento: Procedimento[];

  constructor(private relatorioService: RelatorioProcedimentoService,
    private filialService: FilialService,
    private procedimentoService: ProcedimentoService,
    private formBuilder: FormBuilder) {

    this.formularioDeMarcacaoDeExames = this.formBuilder.group({
      filial: ['', [Validators.required]],
      dataInicial: ['', [Validators.required]],
      procedimentos: ['', [Validators.required]],
    });

    this.listaFiliais = [];

    this.listaDeProcedimento = [];
  }

  ngOnInit() {

    this.listarFiliais();

    this.listarProcedimentos();
  }

  onSubmit() {
    this.gerarRelatorio();
  }

  gerarRelatorio(): void {

    const relatorioDTO: RelatorioDTO = Object.assign(new RelatorioDTO(), this.formularioDeMarcacaoDeExames.value);

    const procedimentos: Procedimento[] = this.controlProcedimentos.value;
    const idsProcedimentos: number[] = [];

    procedimentos.forEach((element) => {
      idsProcedimentos.push(element.id);
    });

    relatorioDTO.idsNumberArray = idsProcedimentos;

    this.relatorioService.gerarRelatorioDeMarcacoes(relatorioDTO)
      .subscribe((response: BlobPart) => {
        const file = new Blob([response], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      });
  }

  listarFiliais() {
    this.filialService.semRelacionamento()
      .subscribe(data => {
        // console.log(data)
        this.listaFiliais = data;

      }, error => {
        console.log(error);
      });
  }

  listarProcedimentos() {
    this.procedimentoService.listarComProjecao()
      .subscribe(data => {
        // console.log(data)
        this.listaDeProcedimento = data;

      }, error => {
        console.log(error);
      });
  }

  get controlProcedimentos() {

    return this.formularioDeMarcacaoDeExames.controls.procedimentos;

  }

}
